import { Hint, Label, Select } from '@lokalise/louis';
import { useUID } from 'react-uid';

type Option = { value: string; label: string };

interface TagsInputProps {
    label: string;
    value: readonly Option[];
    options: readonly Option[];
    hint: string;
    onChange: (value: readonly Option[]) => void;
}

const TagsInput = ({ options, label, value, hint, onChange }: TagsInputProps) => {
    const id = useUID();

    return (
        <Label
            text={
                <>
                    {label} <Hint>{hint}</Hint>
                </>
            }
            id={id}
        >
            <Select
                value={value}
                options={options}
                isMulti
                onChange={onChange}
                aria-labelledby={id}
                placeholder="Search for a tag"
            />
        </Label>
    );
};

export default TagsInput;
